import { LandingContent } from "./types";

export const partnerNetworkLanding: LandingContent = {
  ctaText: "Open Partner Network",
  quickFacts: ["No cost to join", "No forfeitures", "Quarterly payouts"],
  whyHeading: "Why teams use Partner Network",
  why: "The greatest strength of CertainPath Partner Network is connecting you with premier manufacturers, distributors, and service providers in your trade — and then, regardless of your business size, facilitating industry-leading rebates and discounts far greater than those you'll find anywhere else. Members report quarterly purchases, get rebates on what they were already buying, and unlock 'double-dip' opportunities that compound through both manufacturer and distributor relationships.",
  advantages: [
    {
      title: "Partner Connections directory",
      description:
        "Browse 100+ vendor partnerships with exclusive savings, contact reps directly, and access onboarding forms — all in one searchable directory.",
      includedNote: "Industry-leading rebate rates",
    },
    {
      title: "Quarterly rebate reporting",
      description:
        "Report your purchases each quarter on a single page. Most members get a quarterly check, an ACH transfer, or a bill credit applied automatically.",
      includedNote: "No minimum purchase requirement",
    },
    {
      title: "Double-dip strategy",
      description:
        "Stack manufacturer rebates on top of distributor rebates — for example, Goodman 3.5% + Home Depot Pro 3.5% = 7% on the same purchase.",
      includedNote: "Double-dip on manufacturer + distributor",
    },
  ],
  featureChecklist: [
    "Industry-leading rebate rates",
    "No minimum purchase requirement",
    "Double-dip on manufacturer + distributor",
    "No forfeitures — late reporting still pays",
  ],
  highlights: [
    {
      title: "Distributor Locator",
      description:
        "Find Partner-network distributors near you in seconds, with full contact info and product coverage shown.",
    },
    {
      title: "Payment reconciliation reports",
      description:
        "PPCF, PPACF, Member Reported Values, Partner Payment, and Rebate History reports let you verify every dollar — no missing rebates.",
    },
    {
      title: "No forfeitures",
      description:
        "Even if you miss a quarter's reporting deadline, your rebates still pay. We strongly recommend reporting on time, but missing a quarter never costs you the rebate.",
    },
  ],
  steps: [
    {
      title: "Sign in & explore",
      description:
        "Log into MyCertainPathHUB and open Partner Network. Browse the partner directory, filter by category, and identify the brands you already buy.",
    },
    {
      title: "Submit PPCF & PPACF forms",
      description:
        "Tell us your distributor account numbers (PPCF) and any direct-account relationships (PPACF). This is what links your purchases to your rebates.",
    },
    {
      title: "Report quarterly purchases",
      description:
        "Each quarter, log paid invoice totals per partner. You have 40 days after quarter-end. (No forfeitures — but on-time reporting catches errors faster.)",
    },
    {
      title: "Get paid",
      description:
        "Rebates land as quarterly checks, ACH transfers, or distributor bill credits. Reconcile against the Partner Payment Report to ensure every dollar is captured.",
    },
  ],
  testimonials: [
    {
      quote:
        "We were already buying from these manufacturers. Partner Network just turned that spend into a five-figure rebate check every quarter. It's the easiest money we've ever made.",
      initials: "PN",
      name: "Operations GM",
      attribution: "CertainPath member · HVAC contractor",
      stats: [
        { label: "Annual rebates", value: "$50k+" },
        { label: "Cost to join", value: "$0" },
      ],
    },
  ],
  faqs: [
    {
      question: "What does it cost to join?",
      answer:
        "Nothing. Partner Network is included with every CertainPath membership at no additional cost.",
    },
    {
      question: "What if I'm not currently buying from a Partner?",
      answer:
        "Click the 'Not a customer yet, but interested' option on any Partner page. We'll connect you with the rep so you can evaluate the relationship.",
    },
    {
      question: "What happens if I miss a quarterly reporting deadline?",
      answer:
        "Your rebates still pay — there are no forfeitures. We strongly recommend reporting on time so any discrepancies can be caught and corrected quickly.",
    },
    {
      question: "What's a 'double-dip' opportunity?",
      answer:
        "Many manufacturers AND their distributors both offer rebates. Buying a Goodman unit through Home Depot Pro, for example, can yield rebates from both — stacking up to 7% on the same invoice.",
    },
    {
      question: "How are rebate payments delivered?",
      answer:
        "Most rebates pay quarterly by check or ACH transfer. Some Partners issue them as bill credits on your distributor account. You can see the breakdown in the Partner Payment Report.",
    },
    {
      question: "Who do I contact for help?",
      answer:
        "Call the dedicated Partner Network team at 945-270-8075 or email PartnerNetwork@MyCertainPath.com. They'll help you maximize savings and resolve any payment discrepancies.",
    },
  ],
  closing: {
    heading: "Stop leaving rebates on the table",
    body: "Most new members find five-figure rebate opportunities in their first quarter. Sign in to MyCertainPathHUB and open Partner Network to get started.",
  },
};
